import classNames from "classnames";
import { BasicProps } from "../../../common/components/ComponentsInterface";
import { LSubTitle } from "../../../common/components/LSubtitle";
import { LTitle } from "../../../common/components/LTitle";

export const SignupContainer = ({ ...props }: ContainerProps): JSX.Element => {
    const classes = classNames("box", "move-up-3");
    return (
        <div className={classes}>
            {props.title && <LTitle size="4">{props.title}</LTitle>}
            {props.subTitle && <LSubTitle size="7">{props.subTitle}</LSubTitle>}
            {props.description && <LSubTitle size="7">{props.description}</LSubTitle>}
            {props.children}
        </div>
    );
};

interface ContainerProps extends BasicProps {
    title?: string;
    subTitle?: string;
    description?: string;
}
